import { ProviderConfig } from 'launchdarkly-react-client-sdk';

const LAUNCH_DARKLY_CONFIG: ProviderConfig = {
  clientSideID: import.meta.env.VITE_LAUNCH_DARKLY_KEY ?? '',
};

export { LAUNCH_DARKLY_CONFIG };
